class DuepaSupportForm extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const {signal} = this.controller;
    const form = this.querySelector('form');
    const button = form?.querySelector('button[type="submit"]');
    if (!form || !button) return;
    const label = button.textContent;
    const restore = () => { this.removeAttribute('aria-busy'); button.textContent = label; };
    form.addEventListener('submit', event => {
      if (event.defaultPrevented || !form.checkValidity()) return;
      this.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.pendingLabel || label;
    }, {signal});
    window.addEventListener('pageshow', restore, {signal});
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('duepa-support-form')) customElements.define('duepa-support-form', DuepaSupportForm);
